import { Injectable } from '@angular/core';
import { catchError , retry } from 'rxjs/internal/operators';
import { Observable } from 'rxjs';
import { HttpClientModule,HttpHeaders,HttpClient, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { CartProduct, Product } from '../classes/orders';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';

@Injectable({
	providedIn: 'root'
})

@Injectable({
	providedIn: 'root'
})
export class WarehouseService {
	key = 'UET6DFMPAXW7BKCB';
	items: Product[] = [];
	config: any;
	user : any = [];
	constructor(private http: HttpClient,private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})

		this.globalSearchService.user.subscribe( (result: any) => {
			this.user = result;
		});
	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type':	'application/json',
		})
	};



	public saveQuote(customer: any, items: any,totals: any, user:any) {
		const method = 'warehouse/savequote';
		 return this.http.post(this.setEndPoint(method), { customer:customer, items: items } , this.httpOptions).pipe(
			 catchError(this.handleError(method, customer))
		 );
	}

	public getDashBaord() {
		const method = 'warehouse/dashboard';
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * Board rollup — one row per open order plus floor stats and the day's cutoff
	 * deadlines. `stage` picks which counter it measures: 'pick' is picked
	 * against pick, 'check' is loaded against picked. Read-only; the counting
	 * writes still go over the socket.
	 */
	public getPickBoard(loccode: any = '', stage: any = 'pick', groupby: any = '', filters: any = null) {
		let method = 'warehouse/pickboard/board&stage=' + encodeURIComponent(stage);
		// A comma list watches several warehouses at once; the literal ALL watches
		// every one. Always sent, because omitting it means "the user's default"
		// server-side — which is not the same as "all".
		const loc = Array.isArray(loccode) ? loccode.join(',') : `${loccode || ''}`;
		method += '&loccode=' + encodeURIComponent(loc === '' ? 'ALL' : loc);
		if (groupby && groupby !== '') {
			method += '&groupby=' + encodeURIComponent(groupby);
		}
		// A wall board's own filters, held in that screen's localStorage. Each is a
		// comma list; a trailing `*` means prefix, so `B*` is a whole room.
		if (filters) {
			if (filters.__countonly) {
				method += '&countonly=1';
			}
			// `deliveryroute`, not `route` — OpenCart's router owns ?route=.
			for (const key of ['shipvia', 'area', 'deliveryroute', 'zip', 'bins', 'line']) {
				const raw = filters[key];
				const val = Array.isArray(raw) ? raw.join(',') : `${raw || ''}`.trim();
				if (val !== '') {
					method += '&' + key + '=' + encodeURIComponent(val);
				}
			}
		}
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * How many orders a pending filter set would match — asked by the settings
	 * panel before saving, so nobody configures a screen that shows nothing.
	 * Returns stats only, no order rows.
	 */
	public previewPickBoard(loccode: any = '', stage: any = 'pick', groupby: any = '', filters: any = null) {
		return this.getPickBoard(loccode, stage, groupby, { ...(filters || {}), __countonly: true });
	}

	/** Live option lists for a board's settings panel, counted over open work. */
	public getPickBoardFilterOptions(loccode: any = '') {
		const loc = Array.isArray(loccode) ? loccode.join(',') : `${loccode || ''}`;
		const method = 'warehouse/pickboard/filteroptions&loccode='
			+ encodeURIComponent(loc === '' ? 'ALL' : loc);
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * Header + lines for one order, sorted by whatever this site walks.
	 * `groupby` comes from the tenant's asset config (picking.groupBy); leaving
	 * it empty lets the server's own config decide.
	 */
	public getPickOrder(orderno: any, stage: any = 'pick', groupby: any = '') {
		let method = 'warehouse/pickboard/order&orderno=' + encodeURIComponent(orderno)
			+ '&stage=' + encodeURIComponent(stage);
		if (groupby && groupby !== '') {
			method += '&groupby=' + encodeURIComponent(groupby);
		}
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * The shared cutoff times. Server config, not per-screen: every board has to
	 * agree about when the truck leaves.
	 */
	public getPickCutoffs() {
		const method = 'warehouse/pickboard/cutoffconfig';
		return this.http.get(this.setEndPoint(method));
	}

	/** Replaces the shared cutoff set. Affects every board, not just this screen. */
	public savePickCutoffs(cutoffs: any[]) {
		const method = 'warehouse/pickboard/cutoffsave';
		return this.http.post(this.setEndPoint(method), { cutoffs: cutoffs });
	}

	/** What the floor screens are allowed to do — auto-invoice flags, roll width. */
	public getPickSettings() {
		const method = 'warehouse/pickboard/settings';
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * Called after a stage is closed out. The server decides whether this order
	 * invoices itself; a refusal comes back as success with a `reason`, not an
	 * error, so the station can say why in plain words.
	 */
	public finalizeStage(orderno: any, stage: any) {
		const method = 'warehouse/pickboard/finalize';
		return this.http.post(this.setEndPoint(method), { orderno, stage }, this.httpOptions).pipe(
			catchError(this.handleError(method, orderno))
		);
	}

	/**
	 * Record one count against a line over HTTP.
	 *
	 * Only used when the socket is down — the socket's own handler performs this
	 * same write, and `count` is a delta, so calling both would double it.
	 */
	public countPick(data: any) {
		const method = 'warehouse/pickboard/count';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	/** Claim (or release) an order so two pickers don't walk the same aisles. */
	public claimPickOrder(orderno: any, userid: any, release = false) {
		const method = 'warehouse/pickboard/claim';
		return this.http.post(this.setEndPoint(method), { orderno, userid, release }, this.httpOptions).pipe(
			catchError(this.handleError(method, orderno))
		);
	}

	/* ── Warehouse visit console (apir/warehouse/visits/*) ──────────────
	   MOOV-only: the scheduler tables ship with the b2b portal's migration
	   083, and the endpoint answers success:false on a company without them. */

	/** One week of visits, the published windows and the open-slot counts. */
	public getWarehouseVisitWeek(weekstart: string, loccode: string) {
		const method = 'warehouse/visits/week'
			+ '&weekstart=' + encodeURIComponent(weekstart || '')
			+ '&loccode=' + encodeURIComponent(loccode || '');
		return this.http.get(this.setEndPoint(method), this.httpOptions);
	}

	/**
	 * One console action: decide | mark | move | note | blackout | unblock |
	 * hours | hoursdel. They all take a JSON body and answer
	 * { success, message? }, so one method beats eight near-identical ones.
	 */
	public warehouseVisitAction(action: string, data: any) {
		const method = 'warehouse/visits/' + action;
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	private setEndPoint(method: any) {
		return this.getApi()+method+this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		 return '&key='+this.config.apiCredentials.clientId+'&userid='+this.user.user.userid;
	}

	public getKey() {
		return '&apikey='+this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			return error;
		};
	}

}
